import { useState } from "react";
import { toast } from "sonner";
import { Field, inputClass, primaryButton } from "@/components/settings/primitives";
import { supabase } from "@/lib/supabase";
import { authErrorMessage } from "@/lib/authErrors";

export function ChangePasswordForm({ email, testIdPrefix }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next.length < 8) return setError("Use at least 8 characters.");
    if (next !== confirm) return setError("The new passwords don't match.");
    setBusy(true);
    try {
      const check = await supabase.auth.signInWithPassword({ email, password: current });
      if (check.error) throw new Error(check.error.code === "invalid_credentials" ? "Your current password is incorrect." : authErrorMessage(check.error));
      const { error: updateError } = await supabase.auth.updateUser({ password: next });
      if (updateError) throw new Error(authErrorMessage(updateError));
      setCurrent("");
      setNext("");
      setConfirm("");
      toast.success("Password updated");
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid={`${testIdPrefix}-form`}>
      <Field label="Current password">
        <input type="password" autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)} className={inputClass} data-testid={`${testIdPrefix}-current-input`} />
      </Field>
      <div className="grid gap-4 sm:grid-cols-2">
        <Field label="New password">
          <input type="password" autoComplete="new-password" value={next} onChange={(e) => setNext(e.target.value)} className={inputClass} data-testid={`${testIdPrefix}-new-input`} />
        </Field>
        <Field label="Confirm new password">
          <input type="password" autoComplete="new-password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className={inputClass} data-testid={`${testIdPrefix}-confirm-input`} />
        </Field>
      </div>
      {error && <p className="text-sm text-rose-300" data-testid={`${testIdPrefix}-error`}>{error}</p>}
      <button type="submit" disabled={busy || !current || !next || !confirm} className={primaryButton} data-testid={`${testIdPrefix}-submit-button`}>
        {busy ? "Updating…" : "Update password"}
      </button>
    </form>
  );
}
